import { render, staticRenderFns } from "./create-user-group.vue?vue&type=template&id=562e6f70&"
import script from "./create-user-group.vue?vue&type=script&lang=tsx&"
export * from "./create-user-group.vue?vue&type=script&lang=tsx&"
import style0 from "./create-user-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports